/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export { Centered } from '../common.style';

export const Heading = styled.h1({
  textAlign: 'center',
});

export const Description = styled.div({
  marginTop: `${gridSize() * 3}px`,
  textAlign: 'center',
});

export const ImageContainer = styled.div({
  marginTop: `${gridSize() * 5}px`,
  width: `${gridSize() * 15}px`,
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'column',
  '> img': {
    width: '100%',
  },
});
